import React from 'react';
import { FormState, Form as FormStateForm } from 'react-formstate';
import classNames from 'classnames';
import WiredInput from '../components/WiredInput';
import T from '../components/T';
import { focusOnFirstInvalid, onlyChangedModel, populateFormErrors } from '../../utils/validation';
import ValidationMessage from '../components/ValidationMessage';
import WiredTextArea from '../components/WiredTextArea';
import Images from './Images';

export default class Form extends React.Component {
  constructor(props) {
    super(props);

    const {
      campaignName,
      description,
      targetAmount,
      lengthInDays,
      image,
      allImages,
      currentDonatedAmount,
      companyName
    } = props.fields;

    this.formState = FormState.create(this);
    this.state = this.formState.injectModel({
      campaignName, description, targetAmount, lengthInDays, image, allImages, currentDonatedAmount, companyName
    });

    console.log(currentDonatedAmount);
  }

  componentDidMount() {
    this.redactor = Redactor('#redactor', {
      minHeight: '10rem',
    });

    const { fields: { description }, disableForm } = this.props;
    if (description) {
      this.redactor.source.setCode(description);
    }
  }

  componentWillReceiveProps({ disableForm: nextDisableForm }) {
    const { disableForm } = this.props;

    if (disableForm !== nextDisableForm) {
      this.toggleRedactorState(nextDisableForm);
    }
  }

  toggleRedactorState = (shouldBeDisabled) => {
    if (!this.redactor) return;

    shouldBeDisabled ? this.redactor.enableReadOnly() : this.redactor.disableReadOnly()
  }

  addImage = (base64) => {
    const context = this.formState.createUnitOfWork();

    const allImages = context.get('allImages');

    if (!allImages.find(image => image === base64)) {
      allImages.push({ id: '', url: base64 });
      context.set('allImages', allImages);
    }

    context.set('image', base64);
    context.updateFormState();
  };

  onInputChange = ({ target: { name, value } }) => {
    const context = this.formState.createUnitOfWork();
    context.set(name, value).validate();

    context.updateFormState();
  };

  onSubmit = (e) => {
    e.preventDefault();

    const context = this.formState.createUnitOfWork();

    if (this.redactor) {
      const content = this.redactor.source.getCode();
      context.set('description', content).validate();
      context.updateFormState();
    }

    const model = context.createModel();

    if (model) {
      const { onSubmit } = this.props;
      onSubmit(e, onlyChangedModel(context.formState, model));
    } else {
      focusOnFirstInvalid(this.formState, this);
    }
  };

  render() {
    const {
      onCancel,
      fields: {
        startsAt,
        daysLeft,
        currentDonatedAmount = 0,
        allowAuthorToUploadCustomImages = true,
        kind
      },
      serverErrors,
      disableForm
    } = this.props;

    const images = this.formState.get('allImages') || [];

    const errors = populateFormErrors(this.formState, serverErrors);

    const msInDay = 1000 * 60 * 60 * 24;

    const now = Date.now();
    const startsAtDate = new Date(Date.parse(startsAt));
    const endsAtDate = new Date(Date.parse(startsAt));
    const maxEndsAtDate = new Date(Date.parse(startsAt));
    endsAtDate.setHours(23);
    endsAtDate.setMinutes(59);
    endsAtDate.setSeconds(59);
    maxEndsAtDate.setHours(23);
    maxEndsAtDate.setMinutes(59);
    maxEndsAtDate.setSeconds(59);
    endsAtDate.setDate(startsAtDate.getDate() + +this.formState.get('lengthInDays'));
    maxEndsAtDate.setDate(startsAtDate.getDate() + window.DRJM.config.maximumCampaignLengthInDays);

    const daysLeftUntilCampaignEnds = Math.round((endsAtDate.getTime() - now) / msInDay);

    const minimumCampaignLengthInDays = Math.max(
      Math.ceil((now - startsAtDate.getTime()) / msInDay),
      window.DRJM.config.minimumCampaignLengthInDays
    );

    const maximumCampaignLengthInDays = Math.min(
      Math.floor((maxEndsAtDate.getTime() - startsAtDate.getTime()) / msInDay),
      window.DRJM.config.maximumCampaignLengthInDays
    );

    const campaignEndsOnFormattedDate = endsAtDate.getDate() + '. ' + (endsAtDate.getMonth() + 1) + '. ' + endsAtDate.getFullYear();

    const minimalTargetAmount = Math.max(
      currentDonatedAmount,
      window.DRJM.config.minimalTargetAmount
    );

    console.log(currentDonatedAmount, minimalTargetAmount);

    return (
      <FormStateForm formState={this.formState} onSubmit={this.onSubmit} className="c-popup campaign-edit">
        <div className="c-inactive-bg__stop">
          <div className="c-popup__head">
            <div className="c-popup__close">
              <a href="#" onClick={onCancel}>
                <i className="icon-close" />
              </a>
            </div>
          </div>

          <fieldset disabled={disableForm}>
            <div className="c-popup__body">
              <header>
                <h1 className="campaign-edit__header">
                  <T msg="campaignEditor.form.title" />
                </h1>
              </header>

              <div>
                <div className="l-row l-no-padding">
                  <div className="l-4-5 l-no-l-padding campaign-edit__inputs">
                    <label className="c-input__wrapper">
                      <span className="c-input__label">
                        <T msg="campaignEditor.form.labels.campaignName" />
                      </span>

                      <span className={classNames(
                        'c-input__border',
                        { 'c-input__border--error': errors.campaignName }
                      )}>
                        <WiredInput
                          name="campaignName"
                          className="c-input"
                          onChange={this.onInputChange}
                          validator={v => v
                            .required().msg('campaignEditor.form.errors.campaignName.required')
                            .minLength(10).msg('campaignEditor.form.errors.campaignName.minLength')
                          }
                        />
                      </span>
                      <ValidationMessage msg={errors.campaignName} />
                    </label>

                    <label className="c-input__wrapper">
                      <span className="c-input__label">
                        <T msg="campaignEditor.form.labels.targetAmount" />
                      </span>
                      <span className={classNames(
                        'c-input__border',
                        { 'c-input__border--error': errors.targetAmount }
                      )}>
                        <WiredInput
                          name="targetAmount"
                          className="c-input"
                          type="number"
                          min={window.DRJM.config.minimalTargetAmount}
                          step="1"
                          onChange={this.onInputChange}
                          validator={(v, context) => {
                            return context.getFieldState('targetAmount').isChanged()
                              ? v.required().msg('campaignEditor.form.errors.targetAmount.required')
                                 .min(minimalTargetAmount).msg('Cieľová suma musí byť aspoň ' + minimalTargetAmount + ' €')
                              : v.required().msg('campaignEditor.form.errors.targetAmount.required')
                                 .min(window.DRJM.config.minimalTargetAmount).msg('Cieľová suma musí byť aspoň ' + window.DRJM.config.minimalTargetAmount + ' €')
                          }}
                        />
                        <span className="c-input__flag campaign-edit__flag campaign-edit__flag--euro">€</span>
                      </span>
                      <ValidationMessage msg={errors.targetAmount} />
                    </label>

                    <label className="c-input__wrapper">
                      <span className="c-input__label">
                        <T msg="campaignEditor.form.labels.lengthInDays" />
                      </span>
                      <span className="campaign-edit__input-with-helper">
                        <span className={classNames(
                          'c-input__border',
                          { 'c-input__border--error': errors.lengthInDays }
                        )}>
                          <WiredInput
                            type="number"
                            min={minimumCampaignLengthInDays}
                            max={maximumCampaignLengthInDays}
                            step="1"
                            pattern="[0-9]"
                            name="lengthInDays"
                            className="c-input"
                            onChange={this.onInputChange}
                            validator={v => v
                              .required().msg('campaignEditor.form.errors.lengthInDays.required')
                              .min(minimumCampaignLengthInDays).msg('campaignEditor.form.errors.lengthInDays.min')
                              .max(maximumCampaignLengthInDays).msg('campaignEditor.form.errors.lengthInDays.max')
                            }
                          />
                          <span className="c-input__flag campaign-edit__flag campaign-edit__flag--cal">&nbsp;</span>
                        </span>

                        <span className="campaign-edit__input-helper">
                          <T msg="campaignEditor.form.labels.campaignEndsOn" formattedDate={campaignEndsOnFormattedDate} />
                          <br />
                          <T msg="campaignEditor.form.labels.campaignRemainingDaysUntilEnd" count={daysLeftUntilCampaignEnds} />
                        </span>
                      </span>

                      <ValidationMessage msg={errors.lengthInDays} />
                    </label>

                    {kind === 'company' && (
                      <label className="c-input__wrapper">
                        <span className="c-input__label">
                          <T msg="campaignEditor.form.labels.companyName" />
                        </span>

                        <span className={classNames(
                          'c-input__border',
                          { 'c-input__border--error': errors.companyName }
                        )}>
                          <WiredInput
                            name="companyName"
                            className="c-input"
                            onChange={this.onInputChange}
                            validator={v => v
                              .required().msg('campaignEditor.form.errors.companyName.required')
                              .minLength(1).msg('campaignEditor.form.errors.companyName.minLength')
                            }
                          />
                        </span>
                        <ValidationMessage msg={errors.companyName} />
                      </label>
                    )}
                  </div>
                </div>

                <div className="l-row l-no-padding">
                  <div className="l-4-5 l-no-l-padding">
                    <label className="c-input__wrapper">
                      <span className="c-input__label">
                        <T msg="campaignEditor.form.labels.description" />
                      </span>
                      <span>
                        <WiredTextArea
                          name="description"
                          className="c-input"
                          rows={15}
                          style={{ display: 'none' }}
                          readOnly
                          validator={v => v
                            .required().msg('campaignEditor.form.errors.description.required')}
                        />
                        <textarea id="redactor" />
                      </span>

                      <ValidationMessage msg={errors.description} />
                    </label>
                  </div>
                  <div className="l-1-5 l-no-r-padding l-no-tablet">
                    <span className="campaign-edit__input-helper campaign-edit__input-helper--below-label">
                      <T msg="campaignEditor.form.labels.descriptionNote" />
                    </span>
                  </div>
                </div>

                <div className="l-row l-no-padding">
                  <div className="l-4-5 l-no-l-padding">
                    <Images
                      name="image"
                      addImage={this.addImage}
                      onInputChange={this.onInputChange}
                      images={images}
                      allowAuthorToUploadCustomImages={allowAuthorToUploadCustomImages}
                    />
                  </div>
                  <div className="l-1-5 l-no-r-padding l-no-tablet">
                    <span className="campaign-edit__input-helper campaign-edit__input-helper--below-label">
                      <T msg={allowAuthorToUploadCustomImages ? 'campaignEditor.form.labels.imagesNoteAndUploadNote' : 'campaignEditor.form.labels.imagesNote' } />
                    </span>
                  </div>
                </div>

                <div className="expander" />
                <div className="expander--1-2" />

                <div className="campaign-edit__bottom-buttons">
                  <button type="submit" className="campaign-edit__button campaign-edit__button--submit c-button">
                    <span className="c-button__content">
                      <T msg="campaignEditor.form.actions.saveCampaign" />
                    </span>
                  </button>

                  <button
                    type="button"
                    className="campaign-edit__button campaign-edit__button--cancel c-button"
                    onClick={onCancel}
                  >
                    <span className="c-button__content">
                      <T msg="campaignEditor.form.actions.cancel" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </FormStateForm>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/campaignEditor/Form.js